import { render } from "./template.pug?vue&type=template&id=8687769a&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./style.sass?vue&type=style&index=0&id=8687769a&lang=sass&scoped=true"

import exportComponent from "C:\\steven\\LIFF\\new balance\\會員系統CRM\\2023_newbalance_crm_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8687769a"]])

export default __exports__